
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { login, ptlogin } from '../service/getdata'
import areaList from '../components/areaList.vue'
import countries from '../components/countryList'
export default {
components: {
XHeader,
Toast,
areaList
},
data() {
return {
icon: "", //选中国家的图标
dialCode: 1, //选中国家的区号
type: 1, //登录类型。1:账号 2邮箱 3手机号
username: "", //登录名
password: "", //密码
msg: "", //提示框内容
show: false, //提示框是否提示
app_name: "BYDYi",
input_type: 'password' 
}
},
created() {
this.username = window.sessionStorage.getItem('username') || ''
this.password = window.sessionStorage.getItem('password') || ""
const lang = window.localStorage.getItem("lang") || 'en'
this.countriesFind = countries[lang]
this.getAppName()
},
computed:{
...mapState(['url'])
},
methods: {
...mapMutations(['SETTOKEN', 'SETUSERNAME']),

getName (params) {
this.icon = params.code;
this.dialCode = params.dialCode;
},
onSelectArea ()  {
this.$refs.controlChildRef.open();
},
getAppName(){
var that = this
ptlogin().then(function(res){
var res = res.data;
that.app_name = res.data.logan || 'BYDYi'







}.bind(this),function(){
console.log("error")
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/relogin.vue